exports = module.exports = require("../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._mask__mask__2wp7Q {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  display: flex;\n  background-color: rgba(0, 0, 0, 0.1);\n  z-index: 900; }\n  ._mask__mask__2wp7Q > div {\n    margin: auto; }\n", ""]);

// exports
exports.locals = {
	"mask": "_mask__mask__2wp7Q"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]__[hash:base64:5]!./~/postcss-loader!./~/sass-loader!./~/rctui/styles/_mask.scss
// module id = 394
// module chunks = 0 1